import { SET_FIELD, REMOVE_FIELD, SET_WORKFLOW_DATA, INITIALIZE, SET_CEF_APPLICATION_FIELD } from "./ActionTypes";
export var setField = function setField(payload) {
  return {
    type: SET_FIELD,
    payload: payload
  };
};
export var setCefApplicationField = function setCefApplicationField(payload) {
  return {
    type: SET_CEF_APPLICATION_FIELD,
    payload: payload
  };
};
export var removeField = function removeField(payload) {
  return {
    type: REMOVE_FIELD,
    payload: payload
  };
};
export var setWorkflowData = function setWorkflowData(payload) {
  return {
    type: SET_WORKFLOW_DATA,
    payload: payload
  };
};
export var initializeStore = function initializeStore(payload) {
  return {
    type: INITIALIZE,
    payload: payload
  };
};